import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Slides from '@ifeng-fe/ui_pc_slides';

import { formatImage } from '@ifeng-fe/public_method';

import { Poster } from '../modal';

class AreaReports extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    handleClick = item => {
        if (item) {
            Poster.show({ content: <img src={item.image} title={item.desc} /> });
        }
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        // eslint-disable-next-line consistent-this
        const that = this;

        const sliderTmpl = function sliderTmpl(item, show, index) {
            // console.log(item, index);s

            return (
                <div className={styles.slideItem} onClick={() => that.handleClick(item)}>
                    <img src={item.image ? formatImage(item.image, 1000, 562) : ''} title={item.desc} />
                </div>
            );
        };

        const sliderConfig = {
            arrows: true,
            autoplay: false,
            dots: false,
            dotsAction: 'hover',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            unitSize: 1000,
            speed: 500,
            infinite: true,
            sliderTmpl,
        };

        return (
            <div className={styles.slides}>
                <Slides content={content} config={sliderConfig} />
            </div>
        );
    }
}

export default errorBoundary(AreaReports);
